import { render, staticRenderFns } from "./SuggestedStartupsTable.vue?vue&type=template&id=135892c5&scoped=true&"
import script from "./SuggestedStartupsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./SuggestedStartupsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135892c5",
  null
  
)

export default component.exports